import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"
import { MuiTelInput } from "mui-tel-input"
import { Controller, useController } from "react-hook-form"

const TelInput = ({ control, name, autoFocus = null, label, type, required, defaultValue = true }) => {
    const { _ } = useLingui()
    return (
        <Controller
                name={name}
                control={control}
                defaultValue=""
                render={({ field, fieldState }) => (
                  <MuiTelInput
                    // <TextField
                    placeholder='+xxx xxxxxx'
                    margin={'dense'}
                    required
                    fullWidth
                    label={_(msg`${label}`)}
                    error={!!fieldState.error}
                    helperText={fieldState.error ? fieldState.error.message : null}
                    {...field}
                  />
                )}
                rules={{
                  pattern  : { value: /^\+[0-9 ]{6,16}$/, message: _(msg`Telephone number must be a number between 6 and 16 digits`) }
                }}
              />
    )
}
export default TelInput